module.exports = __webpack_public_path__ + "img/veritranscard.0892b1f0.png";